export const environment = {
  production: false,
  //apiUrl: 'http://localhost:6080/api'
  apiUrl: 'https://farmaflow-api.tatusolutions.com/api'
};
